export const TOGGLE_ASSIGN_MODAL_REPO = 'TOGGLE_ASSIGN_MODAL_REPO';
export const ARCHIVE_SEARCH = 'ARCHIVE_SEARCH';
export const REPORT_HOURS = 'REPORT_HOURS';
export const USERS_HOURS = 'USERS_HOURS';
export const TRAZABILITY_HOURS = 'TRAZABILITY_HOURS';
export const TIMELINE_HOURS = 'TIMELINE_HOURS';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
